import D1 from '../../components/ExcerciseTypes/Design/TypeIn'
import T6 from '../../components/ExcerciseTypes/TypeIn/T6'

const json = {
	1: {
		// Exercise num
		unit: 'Unit 2',
		id: '4WB-U2-P17-E1',
		audio: '',
		exerciseKey: 'img/FriendsPlus/Page17/E1/Key/E1answerKey.png',
		// exerciseKey: 'img/FriendsPlus/Page39/Key/E2answerKey.png',
		component: T6,
		inputSize: 178,
		textAlign: 'center',
		maxLength: 15,
		textareaStyle: {
			width: 170,
			height: 65,
			fontSize: 20,
		},
		stylesTextInput: {
			background: 'none',
			borderBottom: 'none',
			fontSize: 22,
			height: 22,
		},
		isHiddenCheck: true,
		titleQuestion: [
			{
				num: '1',
				title: 'Follow the maze and write.',
				color: '#234090',
			},
		],
		hintBox: [
			{
				src: [
					'hospital',
					'school',
					'airport',
					"<s style='color:gray'>police station</s>",
					'fire station',
					'store',
				],
				width: 850,
				borderColor: 'rgb(133,208,151)',
				fontSize: 20,
			},
		],
		questions: [
			{
				title: `
        <hintbox id='0' ></hintbox>
        <div style=" position: relative; ">
					<div> <img style='width:20cm' src='img/FriendsPlus/Page17/E1/1.jpg' /> </div>
            <div style=" position: absolute; top:145px; left: 565px;">#</div>
            <div style=" position: absolute; top:216px; left: 575px;"><textarea id='1' row='2'></textarea></div>
            <div style=" position: absolute; top:316px; left: 575px;"><textarea id='2' row='2'></textarea></div>
            <div style=" position: absolute; top:412px; left: 575px;"><textarea id='3' row='2'></textarea></div>
            <div style=" position: absolute; top:509px; left: 575px;"><textarea id='4' row='2'></textarea></div>
            
				</div>

          `,
				answer: [
					'school',
					'He works in an airport',
					'She works in a fire station',
					'He works in a store',
					'She works in a hospital',
				],
			},
		],
	},
	2: {
		// Exercise num
		unit: 'Unit 2',
		id: '4WB-U2-P17-E2',
		audio: '',
		exerciseKey: 'img/FriendsPlus/Page17/E2/Key/E2answerKey.png',
		// exerciseKey: 'img/FriendsPlus/Page39/Key/E2answerKey.png',
		component: T6,
		inputSize: 178,
		textAlign: 'center',
		maxLength: 1,

		titleQuestion: [
			{
				num: '2',
				title: 'Match.',
				color: '#234090',
			},
		],

		questions: [
			{
				title: `

        <div style=" position: relative; ">
					<div> <img style='width:25cm; padding-top:30px' src='img/FriendsPlus/Page17/E2/1.jpg' /> </div>
            <div style=" position: absolute; top:147px; left: 531px;"><input id='0' height='35px' width='35px' border-bottom='0px'></input></div> 
            <div style=" position: absolute; top:243px; left: 488px;"><input id='1' height='35px' width='35px' border-bottom='0px'></input></div>
            <div style=" position: absolute; top:337px; left: 461px;"><input id='2' height='35px' width='35px' border-bottom='0px'></input></div>
            
            
				</div>

          `,
				answer: ['c', 'a', 'd'],
			},
		],
	},
}

export default json
